var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2863 22.7144H13.7148",
    stroke: "#9399b1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 14.1426H22.2863",
    stroke: "#9399b1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 18.4287H22.2863",
    stroke: "#9399b1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5798 7.59413C23.1256 8.6587 22.2964 9.85707 21.1 9.85707H14.843C13.6627 9.85707 12.8328 8.68728 13.3544 7.62847C14.4767 5.35018 15.9148 3.68474 18.0003 1.28564C20.0013 3.67712 21.4223 5.33662 22.5798 7.59413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5719 23.1408C8.17455 23.1408 10.2844 21.0311 10.2844 18.4283C10.2844 15.8257 8.17455 13.7158 5.5719 13.7158C2.96924 13.7158 0.859375 15.8257 0.859375 18.4283C0.859375 21.0311 2.96924 23.1408 5.5719 23.1408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46008 8.09683C1.5513 8.91972 2.21012 9.5783 3.03263 9.67289C3.85521 9.76748 4.70365 9.85707 5.57087 9.85707C6.43809 9.85707 7.28653 9.76748 8.10911 9.67289C8.93162 9.5783 9.59044 8.91972 9.68166 8.09683C9.7724 7.27832 9.85658 6.43416 9.85658 5.57136C9.85658 4.70854 9.7724 3.86439 9.68166 3.04589C9.59044 2.223 8.93162 1.56443 8.10911 1.46983C7.28653 1.37523 6.43809 1.28564 5.57087 1.28564C4.70365 1.28564 3.85521 1.37523 3.03263 1.46983C2.21012 1.56443 1.5513 2.223 1.46008 3.04589C1.36934 3.86439 1.28516 4.70854 1.28516 5.57136C1.28516 6.43416 1.36934 7.27832 1.46008 8.09683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5798 7.59413C23.1256 8.6587 22.2964 9.85707 21.1 9.85707H14.843C13.6627 9.85707 12.8328 8.68728 13.3544 7.62847C14.4767 5.35018 15.9148 3.68474 18.0003 1.28564C20.0013 3.67712 21.4223 5.33662 22.5798 7.59413Z",
    stroke: "#9399b1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5719 23.1408C8.17455 23.1408 10.2844 21.0311 10.2844 18.4283C10.2844 15.8257 8.17455 13.7158 5.5719 13.7158C2.96924 13.7158 0.859375 15.8257 0.859375 18.4283C0.859375 21.0311 2.96924 23.1408 5.5719 23.1408Z",
    stroke: "#9399b1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46008 8.09683C1.5513 8.91972 2.21012 9.5783 3.03263 9.67289C3.85521 9.76748 4.70365 9.85707 5.57087 9.85707C6.43809 9.85707 7.28653 9.76748 8.10911 9.67289C8.93162 9.5783 9.59044 8.91972 9.68166 8.09683C9.7724 7.27832 9.85658 6.43416 9.85658 5.57136C9.85658 4.70854 9.7724 3.86439 9.68166 3.04589C9.59044 2.223 8.93162 1.56443 8.10911 1.46983C7.28653 1.37523 6.43809 1.28564 5.57087 1.28564C4.70365 1.28564 3.85521 1.37523 3.03263 1.46983C2.21012 1.56443 1.5513 2.223 1.46008 3.04589C1.36934 3.86439 1.28516 4.70854 1.28516 5.57136C1.28516 6.43416 1.36934 7.27832 1.46008 8.09683Z",
    stroke: "#9399b1",
    strokeWidth: 1.71429
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_5999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreInactive);
export default __webpack_public_path__ + "static/media/exploreInactive.5d5c2a9be943bfecdbb742c55e7cba09.svg";
export { ForwardRef as ReactComponent };